/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取字典码表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Record<string, Array<dictionary.Codebook>>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/code-book`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
